import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: ({ background }) => ({
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundImage: `url(${background && background.url}?h=320&w=375&fit=fill&fl=progressive&q=80)`,
    [theme.breakpoints.up('sm')]: {
      backgroundImage: `url(${background && background.url}?h=450&w=1440&fit=fill&fl=progressive&q=80)`,
    },
  }),
  location: {
    position: 'relative',
    fontWeight: 'bold',
    paddingBottom: theme.spacing(1),
    '& svg': {
      position: 'relative',
      top: 8,
    },
  },
}))

export default useStyles
